import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { LandingComponent } from './modules/client/landing/landing.component';
import { ContactType01Component } from './modules/client/contact/contact-type01/contact-type01.component';
// Static imports for client layout (SSR/prerender — same chunk as route config)
import landingRoutes from 'app/modules/client/landing/landing.routes';
import contactRoutes from 'app/modules/client/contact/contact.routes';
import aboutRoutes from 'app/modules/client/about/about.routes';
import teamRoutes from 'app/modules/client/team/team.routes';
import searchResultsRoutes from 'app/modules/client/search-results/search-results.routes';
import genericPageRoutes from 'app/layout/common/generic-page/generic-page.routes';
import promotionalRoutes from 'app/layout/common/promotional/promotional.routes';
import nonProfitRoutes from 'app/modules/client/non-profit-organizations/non-profit-organizations.routes';
import corporateTravelRoutes from 'app/modules/client/corporate-travel/corporate-travel.routes';
import leisureTravelRoutes from 'app/modules/client/leisure-travel/leisure-travel.routes';
import membersRoutes from 'app/modules/client/members/members.routes';
import galleryRoutes from 'app/modules/client/gallery/gallery.routes';
import worldCruisesRoutes from 'app/modules/client/world-cruises/world-cruises.routes';
import cruiseDestinationsRoutes from 'app/modules/client/cruise-destinations/cruise-destinations.routes';
import newslettersRoutes from 'app/modules/client/newsletters/newsletters.routes';
import blogRoutes from 'app/modules/client/blog/blog.routes';
import brochureRoutes from 'app/modules/client/brochure/brochure.routes';
import ourSolutionsRoutes from 'app/layout/common/our-solutions/our-solutions.routes';
import onboardingRoutes from 'app/modules/client/onboarding/onboarding.routes';
import destinationRoutes from 'app/modules/client/destination/destination.routes';
import packagesRoutes from 'app/modules/client/packages/packages.routes';
import confirmationRoutes from 'app/modules/client/confirmation/confirmation.routes';
import bookingFormRoutes from 'app/layout/common/booking-form/booking-form.routes';
import mediaCenterRoutes from 'app/modules/client/media-center/media-center.routes';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Client routes (static imports for SSR/prerender — no loadChildren)
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        title: '',
        children: [
            { path: '', title: 'Home Page', children: landingRoutes },
            { path: 'contact-us', title: 'Contact Us Page', children: contactRoutes },
            { path: 'about-us', title: 'About us Page', children: aboutRoutes },
            { path: 'team', title: 'Our Team Page', children: teamRoutes },
            { path: 'search-results', title: 'Search Results Page', children: searchResultsRoutes },
            { path: 'policy/:slug', title: 'Policy Page', children: genericPageRoutes },
            { path: 'promotional', title: 'Specials Page', children: promotionalRoutes },
            { path: 'non-profit', title: 'Non-Profit', children: nonProfitRoutes },
            { path: 'corporate-travel', title: 'Corporate Travel', children: corporateTravelRoutes },
            { path: 'leisure-travel', title: 'Leisure Travel', children: leisureTravelRoutes },
            { path: 'branches', title: 'Members', children: membersRoutes },
            { path: 'gallery', title: 'Gallery', children: galleryRoutes },
            { path: 'world-cruises', title: 'World Cruises', children: worldCruisesRoutes },
            { path: 'cruise-destinations', title: 'Cruise Destinations', children: cruiseDestinationsRoutes },
            { path: 'newsletter', title: 'Newsletters', children: newslettersRoutes },
            { path: 'blog', title: 'Blog Page', children: blogRoutes },
            { path: 'brochures', title: 'Brochures Page', children: brochureRoutes },
            { path: 'holidays', title: 'Holidays Solutions Page', children: ourSolutionsRoutes },
            { path: 'holidays', title: 'Howzit Solutions Page', children: ourSolutionsRoutes },
            { path: 'onboarding', title: 'Become a Member here', children: onboardingRoutes },
            { path: 'rewards', title: 'Rewards Page', children: ourSolutionsRoutes },
            { path: 'destination/:id/:alias', children: destinationRoutes },
            { path: 'packages', children: packagesRoutes },
            { path: 'confirmation', children: confirmationRoutes },
            { path: 'cic-booking-form', children: bookingFormRoutes },
        ],
    },
    {
        path: 'destination/:id/:alias',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'material'
        },
        title: 'Destination Page',
        children: [
            { path: '', loadChildren: () => import('app/modules/client/destination/destination.routes')},
            { path: 'confirmation', title: 'Confirmation Page', loadChildren: () => import('app/modules/client/confirmation/confirmation.routes')},
            { path: 'payment', title: 'Payment Page', loadChildren: () => import('app/modules/client/payment/payment.routes')}
        ]
    },
    {
        path: 'package/:id/:slug',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        title: 'Package Information',
        children: [
            { path: '', loadChildren: () => import('app/modules/client/package-detail/package-detail.routes')},
        ]
    },
    {
        path: 'media-center',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'modern'
        },
        title: 'Media Center',
        children: [
            { path: '', children: mediaCenterRoutes },
        ]
    },
    {
        path: 'test-client',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'modern'
        },
        title: 'Media Center',
        children: [
            { path: '', loadChildren: () => import('app/layout/common/test-page/test-page.routes')},
        ]
    },
    {
        path: 'checkout/:guid',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            //layout: 'material'
        },
        title: 'Checkout Page',
        children: [
            { path: '', loadChildren: () => import('app/modules/client/checkout/checkout.routes')},
        ]
    },
    {
        path: 'confirmation/:guid',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            //layout: 'material'
        },
        title: 'Confirmation Page',
        children: [
            { path: '', loadChildren: () => import('app/modules/client/confirmation/confirmation.routes')},
        ]
    },
    // {
    // path: 'request-details',
    //     canActivate: [NoAuthGuard],
    //     canActivateChild: [NoAuthGuard],
    //     component: LayoutComponent,
    //     resolve: {
    //         initialData: initialDataResolver
    //     },
    //     data: {
    //         //layout: 'material'
    //     },
    //     title: 'request-details ',
    //     children: [
    //         { path: '', loadChildren: () => import('app/modules/admin/apps/academy/academy.routes')},
    //     ]
    // },

    // Do not redirect '' to dashboard here; the first route (client/layout) handles '' and shows landing.
    // NoAuthGuard redirects to dashboard only when isClient is false and user is authenticated.

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboard'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        data: {
            layout: 'dense'
        },
        children: [

            //Dashboards
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/dashboards/project/project.routes')},
            {path: 'dashboards/travel', loadChildren: () => import('app/modules/admin/dashboards/travel/travel.routes')},
            {path: 'dashboards/client-trips', loadChildren: () => import('app/modules/admin/dashboards/client-trips/client-trips.routes')},
            {path: 'dashboards/commission', loadChildren: () => import('app/modules/admin/dashboards/commission/commission.routes')},
            {path: 'dashboards/product-performance', loadChildren: () => import('app/modules/admin/dashboards/product-performance/product-performance.routes')},
            {path: 'dashboards/suppliers', loadChildren: () => import('app/modules/admin/dashboards/suppliers/suppliers.routes')},
            {path: 'ai-travel', loadChildren: () => import('app/modules/admin/ai-travel/ai-travel.routes')},
            // {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},

            //Quotes Details
            {path: 'quote/packages', loadChildren: () => import('app/modules/admin/quote-details/packages/packages.routes')},
            {path: 'quote/flights', loadChildren: () => import('app/modules/admin/quote-details/flights/flights.routes')},
            {path: 'quote/stays', loadChildren: () => import('app/modules/admin/quote-details/stays/stays.routes')},
            {path: 'quote/cars', loadChildren: () => import('app/modules/admin/quote-details/cars/cars.routes')},
            {path: 'quote/transfers', loadChildren: () => import('app/modules/admin/quote-details/transfers/transfers.routes')},
            {path: 'quote/activities', loadChildren: () => import('app/modules/admin/quote-details/activities/activities.routes')},
            {path: 'quote/cruises', loadChildren: () => import('app/modules/admin/quote-details/cruises/cruises.routes')},
            
            //Resources
            {path: 'trips/requests', loadChildren: () => import('app/modules/admin/apps/trips/trips.routes')},

            {path: 'settings', loadChildren: () => import('app/modules/admin/pages/settings/settings.routes')},
            {path: 'resources', loadChildren: () => import('app/modules/admin/pages/resources/resources.routes')},
            {path: 'reports', loadChildren: () => import('app/modules/admin/pages/reports/reports.routes')},
            {path: 'help-center', loadChildren: () => import('app/modules/admin/pages/help-center/help-center.routes')},
            {path: 'changelog', loadChildren: () => import('app/modules/admin/pages/changelog/changelog.routes')},

            //Bookings
            {path: 'app/trips', loadChildren: () => import('app/modules/admin/apps/trips/trips.routes')},

            //Tasks
            {path: 'app/tasks', loadChildren: () => import('app/modules/admin/apps/tasks/tasks.routes')},

            //Booking Details

            {path: 'academy', loadChildren: () => import('app/modules/admin/apps/trips/trips.routes')},

            {path: 'suppliers/create', loadChildren: () => import('app/modules/admin/pages/resources/suppliers/suppliers.routes')},

        ]
    },

    
  
];
